import pdf from "assets/filetypes/pdf.svg"
import doc from "assets/filetypes/doc.svg"
import docx from "assets/filetypes/docx.svg"
import xls from "assets/filetypes/xls.svg"
import xlsx from "assets/filetypes/xlsx.svg"
import png from "assets/filetypes/png.svg"
import jpeg from "assets/filetypes/jpeg.svg"
import jpg from "assets/filetypes/jpg.svg"
import msg from "assets/filetypes/msg.svg"
import txt from "assets/filetypes/txt.svg"
import ppt from "assets/filetypes/ppt.svg"
import ppsx from "assets/filetypes/ppsx.svg"
import pptx from "assets/filetypes/pptx.svg"

//
import { UserDetails } from "./common"

export type DocType = "Brief" | "Presentation" | "Report" | "ATB" | "Other"

export type FileType =
  | "pdf"
  | "doc"
  | "docx"
  | "xls"
  | "xlsx"
  | "png"
  | "jpeg"
  | "jpg"
  | "msg"
  | "txt"
  | "ppt"
  | "ppsx"
  | "pptx"

export type Document = {
  id?: string
  file?: File
  name: string
  tags?: Array<string>
  ownerEntityId: string
  documentType?: DocType
  mediaType?: string
  description?: string
  dateCreated: number
  dateModified?: number
  createdBy?: string
  createdByDetails?: UserDetails
  fileType?: FileType
  agencyId?: string
}

export const newDocumentEmpty: Document = {
  name: "",
  description: "",
  ownerEntityId: "",
  mediaType: "",
  documentType: undefined,
  dateCreated: 0,
}

export const fileIcons = {
  pdf,
  doc,
  docx,
  xls,
  xlsx,
  png,
  jpeg,
  jpg,
  msg,
  txt,
  ppt,
  ppsx,
  pptx,
}

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const mimeTypes: Record<string, FileType> = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "image/png": "png",
  "image/jpeg": "jpg",
  "application/vnd.ms-outlook": "msg",
  "application/vnd.msoutlook": "msg",
  "text/plain": "txt",
  "application/vnd.ms-powerpoint": "ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
    "ppsx",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "pptx",
}
